import styled from 'styled-components';
import { themeGet } from 'styled-system';

const Stop = styled.stop`
  stop-color: ${({ stopColor }) => themeGet(`colors.${stopColor}`, stopColor)};
`;

export default Stop;
